import { Overlay } from './Overlay';
import { SegmentOverlay } from './SegmentOverlay';
import { Simple } from './Simple';

export const Loader = {
  Overlay,
  SegmentOverlay,
  Simple
}
